import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { OrgBranchStateManagement } from '../../../../../../store/branch/reducer';
import { OrgShiftStateManagement } from '../../../../../../store/shift/reducer';


@Component({
  selector: 'g10-excel-upload-alert',
  templateUrl: './excel-upload-alert.component.html',
  styleUrls: ['./excel-upload-alert.component.css']
})
export class ExcelUploadAlertComponent implements OnInit {

  @Input() popup = false;
  @Input() modalTitle = '';
  @Input() resData;
  @Input() tableInfo;
  @Output() close = new EventEmitter();

  public objKeys = Object.keys;
  public branchList: any = [];
  public shiftList: any = [];
  public existBranchlists = [];
  public existShiftlists = [];
  public successBranchlists = [];
  public successShiftlists = [];

  constructor(
    private branchState: OrgBranchStateManagement,
    private shiftState: OrgShiftStateManagement,
  ) {
    this.branchState.fetchBranchList();
    this.shiftState.fetchShiftList();
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.branchList = this.branchState.get();
      this.shiftList = this.shiftState.get();
    }, 500);
    setTimeout(() => {
      this.getBranchList();
      this.getListShift();
    }, 1000);

  }
  getBranchList() {
    if (this.resData['existsCount'] != 0) {
      let existingKeys = Object.keys(this.resData['exitsData']);
      let branchIds = [];
      for (let i = 0; i < existingKeys.length; i++) {
        branchIds.push(this.resData['exitsData'][existingKeys[i]][0]['branch'])
      }
      for (let i = 0; i < branchIds.length; i++) {
        let branchName = this.branchList.filter(val => val.branchID == branchIds[i]);       
         this.existBranchlists.push(branchName[0]['branchName'])
      }
    }
    // if (this.resData['successCount'] != 0 ) {
    //   let branchIds = [];
    //   for (let i = 0; i < this.resData['success'].length; i++) {

    //     branchIds.push(this.resData['success'][i]['branch'])
    //   }
    //   for (let i = 0; i < branchIds.length; i++) {
    //     let branchName = this.branchList.filter(val => val.branchID == branchIds[i]);
    //     this.successBranchlists.push(branchName[0]['branchName'])
    //   }
    // }
  }
  getListShift() {
    if (this.resData['existsCount'] != 0) {
      let existingKeys = Object.keys(this.resData['exitsData']);
      let shiftIds = [];
      for (let i = 0; i < existingKeys.length; i++) {
        shiftIds.push(this.resData['exitsData'][existingKeys[i]][0]['shift'])
      }
      for (let i = 0; i < shiftIds.length; i++) {
        let shiftName = this.shiftList.filter(val => val?.shiftName == shiftIds[i][0]);
        this.existShiftlists.push(shiftName[0]['shiftName'])
      }      
    }
    // if (this.resData['successCount'] != 0 ) {
    //   let shiftIds = [];
    //   for (let i = 0; i < this.resData['success'].length; i++) {
    //     shiftIds.push(this.resData['success'][i]['shift'])
    //   }
    //   for (let i = 0; i < shiftIds.length; i++) {
    //     let shiftName = this.shiftList.filter(val => val.shiftName == shiftIds[i][0]);
    //     this.successShiftlists.push(shiftName[0]['shiftName'])
    //   }
    // }
  }

  isNumber(o): boolean {
    return !isNaN(o - 0) && o !== null && o !== '' && o !== false;
  }

  closePopup() {
    this.close.emit(true);
  }

}
